import axios from "../plugins/parseAxios";
export class MessageAPI {
  constructor(props) { }
  static createMessage(payload) {
    return axios.post("functions/createMessage", payload);
  }
  static getMessages(payload) {
    return axios.post("functions/getMessages", payload);
  }
}
